import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efc31b20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between mt-3" }
const _hoisted_2 = { class: "DispatcherSectorListItem__information" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "information__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-draw-polygon fa-lg" })
], -1))
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "information__name" }
const _hoisted_6 = { class: "information__sub-name" }
const _hoisted_7 = { class: "DispatcherSectorListItem__actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-red-500" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_15 = { class: "flex items-center justify-between mt-3" }
const _hoisted_16 = { class: "flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["DispatcherSectorListItem", { 'DispatcherSectorListItem--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.item.name), 1),
          _createElementVNode("span", _hoisted_6, " Филиал " + _toDisplayString(_ctx.item.city ? _ctx.item.city.name : '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "actions__button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onView && _ctx.onView(...args)))
        }, _hoisted_9),
        (_ctx.isCanDelete)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "actions__button ml-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
            }, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isCanUpdate)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "actions__button ml-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
            }, _hoisted_13))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.dispatchers, (dispatcher) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `d-${dispatcher.id}`,
          class: "flex flex-col mt-2 text-sm"
        }, [
          _createElementVNode("span", null, _toDisplayString(dispatcher.name), 1),
          _createElementVNode("span", null, _toDisplayString(dispatcher.phone), 1),
          _createElementVNode("span", null, _toDisplayString(dispatcher.email), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_cheap, {
        class: _normalizeClass(["small", { 'green': Boolean(_ctx.item.extendedCoordinates) }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(Boolean(_ctx.item.extendedCoordinates) ? 'Внешние границы установлены': 'Внешние границы не установлены'), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_16, [
        (Boolean(_ctx.item.extendedCoordinates))
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              disabled: _ctx.disabled,
              class: "small primary",
              onClick: _ctx.onUpdateExtendedSector
            }, {
              default: _withCtx(() => [
                _createTextVNode("Редактировать внешние границы")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              disabled: _ctx.disabled,
              class: "small primary",
              onClick: _ctx.onCreateExtendedSector
            }, {
              default: _withCtx(() => [
                _createTextVNode("Установить внешние границы")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
      ])
    ])
  ], 2))
}